import React, { SVGProps } from "react";

const SvgRoof4 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof024 dims 1">
      <path
        fill="#aec1cf"
        d="M122.679 194.058v31.116l68.699-39.766v-31.116l-68.699 39.766z"
      />
      <path
        fill="#fff"
        d="M122.577 194.247v31.116l-91.772-52.861v-40.71l41.25-16.721 50.522 79.176z"
      />
      <path
        fill="#aec1cf"
        d="M225.737 170.446v35.182l92.067-53.07v-41.552l-42.118-17.032-49.949 76.472z"
      />
      <path
        fill="#fff"
        d="M225.737 170.446v35.182l-34.359-20.01v-32.922l34.359 17.75z"
      />
      <g fill="#6d9faf">
        <path d="M75.589 135.277v9.258l-7.697-4.434v-9.257l7.697 4.433zM85.017 140.72v9.258l-7.697-4.433v-9.258l7.697 4.433zM75.589 146.364v9.258l-7.697-4.434v-9.257l7.697 4.433zM85.017 151.808v9.257l-7.697-4.433v-9.258l7.697 4.434z" />
      </g>
      <path
        fill="#2177a8"
        d="m191.495 154.228-68.918 40.019-50.989-78.923 119.908-69.168-.001 108.072z"
      />
      <path
        fill="#46d5ff"
        d="M191.496 46.156 71.588 115.324l-50.154 20.289 170.062-98.362v8.905z"
      />
      <path
        fill="#20709e"
        d="m191.496 46.156-.001-8.915 101.189 58.727 33.708 19.502-49.946-20.174-84.95-49.14z"
      />
      <path
        fill="#4df1ff"
        d="m192.096 45.501-.001 108.072 34.258 19.835 50.693-78.767-84.95-49.14z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="m30.751 131.823.054 40.679 92.487 52.612 68.086-39.706 34.359 20.22 92.067-53.07v-39.907"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M225.737 205.628v-31.565M191.378 185.408v-30.673M122.679 225.174l-.157-30.896"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          d="m191.496 37.251-.118 117.041M71.66 114.847l119.832-68.689M277.046 94.641 191.493 46.16"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m191.378 154.292-68.856 39.986-50.988-78.922-50.154 20.289 170.376-98.469 134.636 78.294-49.646-20.522-50.993 79.115-34.375-19.771z"
        />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m99.682 238.604 17.669-10.212M7.941 185.762l17.626-10.251M12.606 183.479l90.832 52.318" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m184.897 261.209-55.663-32.149M253.697 221.611l-20.224-11.751M249.024 219.333l-68.031 39.154" />
      </g>
      <text
        transform="translate(216.34 250.411)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"C"}
      </text>
      <text
        transform="translate(46.148 221.363)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m193.339 224.32 25.703-14.851M163.386 202.175l34.231 19.639" />
      </g>
      <text
        transform="translate(172.204 226.16)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M12.268 179.422v7.72M103.929 232.194v7.72M180.642 254.898v7.72M197.698 217.943v7.72M249.368 215.254v7.72M163.078 198.059v7.72"
      />
      <text
        transform="translate(18.593 112.646)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P1"}
      </text>
      <path
        d="M26.031 133.556c-8.985-17.316-14.32-36.038-14.391-52.762M66.287 112.325 6.323 77.693M14.993 78.855l-6.686 3.86M26.921 129.832l-1.745 7.521"
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        d="M215.388 130.5a74.078 74.078 0 0 0 .589 9.643c1.646 12.74 6.585 22.094 13.768 27.759M212.408 132.079l55.117-31.832M212.084 128.733l6.686 3.86M229.797 171.675v-7.72"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <text
        transform="translate(219.632 150.13)"
        fontSize={16}
        fontFamily="'Effra Regular', Effra"
      >
        {"P2"}
      </text>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m345.195 168.849-20.224-11.751M340.886 166.361l-91.137 52.494" />
      </g>
      <text
        transform="translate(298.323 204.876)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"D"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M340.881 162.532v7.72"
      />
    </g>
  </svg>
);

export default SvgRoof4;
